import React from "react";
import MenuItemCard from "./MenuItemCard";

const MenuCategoryList = ({ menuItems = [] }) => {
  const categories = menuItems.reduce((acc, item) => {
    const category = item.category_id || "other";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});

  return (
    <div className="guest-menu-sections">
      {Object.entries(categories).map(([categoryId, items]) => (
        <section key={categoryId} id={`category-${categoryId}`} className="guest-category-section">
          <h4 className="guest-category-title">{items[0]?.category_name || "Diğer"}</h4>
          <div className="guest-menu-grid">
            {items.map((item) => (
              <MenuItemCard key={item.id} item={item} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default MenuCategoryList;
